const defaultCustomUIName = 'haltadefinizione'
let backendConfiguration = {}

const configuration = {
  haltadefinizione: {
    analyticsCustomerCode: 'haltadefinizione',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  brera: {
    analyticsCustomerCode: 'brera',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  ff2020: {
    analyticsCustomerCode: 'haltadefinizione',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  genericExternal: {
    analyticsCustomerCode: 'haltadefinizione',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  sanRaffaele: {
    analyticsCustomerCode: 'sanraffaele',
    sendInternalAnalytics: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  pololombardia: {
    analyticsCustomerCode: 'pololombardia',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  gnaabarberini: {
    analyticsCustomerCode: 'gnaabarberini',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  fabrizioferrari: {
    analyticsCustomerCode: 'fabrizioferrari',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  fondazionevignola: {
    analyticsCustomerCode: 'fondazionevignola',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  pierluigisterpi: {
    analyticsCustomerCode: 'pierluigisterpi',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  archiviostatomodena: {
    analyticsCustomerCode: 'archiviostatomodena',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  estense: {
    analyticsCustomerCode: 'estense',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  galleriaaccademiafirenze: {
    analyticsCustomerCode: 'galleriaaccademiafirenze',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  galleriaborghese: {
    analyticsCustomerCode: 'galleriaborghese',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  bargellomusei: {
    analyticsCustomerCode: 'bargellomusei',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  asmo: {
    analyticsCustomerCode: 'asmo',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  Uffizi: {
    analyticsCustomerCode: 'Uffizi',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  polotoscana: {
    analyticsCustomerCode: 'polotoscana',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  ballester: {
    analyticsCustomerCode: 'ballester',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  scrovegni: {
    analyticsCustomerCode: 'scrovegni',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  arcidiocesitorino: {
    analyticsCustomerCode: 'arcidiocesitorino',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  enjoymuseum: {
    analyticsCustomerCode: 'enjoymuseum',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: true
  },
  santamariadellascala: {
    analyticsCustomerCode: 'santamariadellascala',
    sendInternalAnalytics: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  open: {
    analyticsCustomerCode: 'open',
    sendInternalAnalytics: false,
    showLogoInFullScreen: false,
    hideToolbar: false
  },
  culturatoscana: {
    analyticsCustomerCode: 'culturatoscana',
    sendInternalAnalytics: false,
    showLogoInFullScreen: false,
    hideToolbar: false
  }
}

export default {
  setBackendConfiguration: (viewersConfig = {}) => {
    backendConfiguration = viewersConfig && typeof viewersConfig === 'object' ? viewersConfig : {}
  },

  getConfigurationFor: (customUIName, propertyName) => {
    if (typeof backendConfiguration[propertyName] !== 'undefined') {
      return backendConfiguration[propertyName]
    }

    const customConfiguration = configuration[customUIName] || configuration[defaultCustomUIName]

    const value = customConfiguration[propertyName]
    return value
  }
}
